import { createBrowserRouter, RouterProvider } from 'react-router-dom-v6'
import { QueryClientProvider } from '@tanstack/react-query'
import { createQueryClient } from '@clouway/query'
// sonner's Toaster directly, themed via prop from our own ThemeProvider (the
// @clouway/ui wrapper hard-depends on next-themes, which dual-loads react under
// the Bazel vitest sandbox).
import { Toaster } from 'sonner'
// Use the same specifier (@/features/auth) as every other consumer
// (AppLayout, Profile): under Bazel's symlink forest a mix of '@/features/auth'
// and './features/auth' resolves to two copies of the SessionContext module —
// the provider fills one while the screens read the other (empty). dedupe only
// covers npm packages, not app source, so the specifier must match everywhere.
import { SessionProvider } from '@/features/auth'
import { ThemeProvider, useTheme } from './components/ThemeProvider'
import { routes } from './routes'

const router = createBrowserRouter(routes)
const queryClient = createQueryClient()

function ThemedToaster() {
  const { theme } = useTheme()
  return <Toaster theme={theme} />
}

function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <SessionProvider>
          <RouterProvider router={router} />
        </SessionProvider>
      </QueryClientProvider>
      <ThemedToaster />
    </ThemeProvider>
  )
}

export default App
